import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import SitesSave from "./SitesSave";
import ClearIndustries from "./SitesClearIndustries";
import GetIndustries from "./SitesGetIndustries";


const SitesEdit = () => {

    const {id} = useParams();
    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});
    
    let response72 = useInvoke("WebApps", "72", {"@AddressID": id});
    
    const [site, setSite] = useState({});
    const [industries, setIndustries] = useState([]);

    useEffect(() => {

        //get site by id
        if (response72.data.payload != undefined) {
            let data = JSON.parse(response72.data.payload).data[0];

            let siteIndustriesList = data[7].split("‡");
            let siteIndustries = [];
            siteIndustriesList.forEach((industry, index) => {
                let n = industry.split(";");
                let obj = {
                    key: index,
                    industryName: n[0],
                    industryID: n[1], 
                    checked: false
                };

                siteIndustries.push(obj);

            });

            let obj = {
                AddressID: data[0], 
                Customer: data[1], 
                Name: data[2], 
                Address: data[3], 
                City: data[4], 
                State: data[5], 
                Zip: data[6], 
                Industry: siteIndustries
            }
            setSite(obj);
        }

    }, [response72.isPending]);

    useEffect(() => {

        if(site["Industry"] != undefined) {
            GetIndustries(id)
        .then((response) => {
            let breakpoint = "";
            let data = JSON.parse(response.payload).data;
            
            let industriesList = [];
            data.forEach((industry, index) => {
                if (industry[1].length > 75) {
                    industry[1] = industry[1].substring(0, 73) + "...";
                }

                let obj = {
                    key: index, 
                    text: `${industry[2]} - ${industry[1]}`, 
                    value: `${industry[0]}`,
                    checked: false
                }

                site["Industry"].forEach((ind) => {
                    if (ind["industryID"] == industry[0].toUpperCase()) {
                        obj["checked"] = true;
                    }
                })

                industriesList.push(obj);
            });

            setIndustries(industriesList);

        });
        }

        
        
    },[site]);
  
    const handleFormSubmit = (e) => {

        ClearIndustries(id)
        .then((response) => {

            if (response) {
                industries.forEach((industry, index) => {
                    if (document.getElementById(`cbInd_${index}`).checked) {
                       SitesSave ("", id, industry["value"], user["id"], "0")
                       .then((response) => {
       
                       });
                    }
                }); 
                toast.success("Successfully saved.");
            }
        });
    };

    document.title = "Sites - Edit";
    return ( 
        <div className="sitesEdit">
            {user["email"] != undefined && 
                <>
                    {site && 
                        <div className="container body-content" style={{marginTop: "25px"}}>
                                
                            <h2>Edit Site</h2>

                            <form id="siteForm" noValidate="novalidate" autoComplete="off">  

                                <div className="form-group" style={{display: "flex", flexDirection: "column"}}>
                                    <label htmlFor="site">Customer&nbsp;</label><span style={{color: "lightgrey"}}>ⓘ&nbsp;JobBOSS Data</span>
                                    <input className="form-control" id="Customer" name="Customer" type="text" readOnly={true} defaultValue={site["Customer"]} autoComplete="off" />
                                </div>

                                <div className="form-group" style={{display: "flex", flexDirection: "column"}}>
                                    <label htmlFor="site">Name&nbsp;</label><span style={{color: "lightgrey"}}>ⓘ&nbsp;JobBOSS Data</span>
                                    <input className="form-control" id="Name" name="Name" type="text" readOnly={true} defaultValue={site["Name"]} autoComplete="off" />
                                </div>

                                <div className="form-group" style={{display: "flex", flexDirection: "column"}}>
                                    <label htmlFor="site">Address&nbsp;</label><span style={{color: "lightgrey"}}>ⓘ&nbsp;JobBOSS Data</span>
                                    <input className="form-control" id="Address" name="Address" type="text" readOnly={true} defaultValue={site["Address"]} autoComplete="off" />
                                </div>

                                <div className="form-group" style={{display: "flex", flexDirection: "column"}}>
                                    <label htmlFor="site">City&nbsp;</label><span style={{color: "lightgrey"}}>ⓘ&nbsp;JobBOSS Data</span>
                                    <input className="form-control" id="City" name="City" type="text" readOnly={true} defaultValue={site["City"]} autoComplete="off" />
                                </div>

                                <div className="form-group" style={{display: "flex", flexDirection: "column"}}>
                                    <label htmlFor="site">State&nbsp;</label><span style={{color: "lightgrey"}}>ⓘ&nbsp;JobBOSS Data</span>
                                    <input className="form-control" id="State" name="State" type="text" readOnly={true} defaultValue={site["State"]} autoComplete="off" />
                                </div>

                                <div className="form-group" style={{display: "flex", flexDirection: "column"}}>
                                    <label htmlFor="site">Zip&nbsp;</label><span style={{color: "lightgrey"}}>ⓘ&nbsp;JobBOSS Data</span>
                                    <input className="form-control" id="Zip" name="Zip" type="text" readOnly={true} defaultValue={site["Zip"]} autoComplete="off" />
                                </div>

                                <div className="form-group">
                                <label>Industries</label>
                                    <div className="accordion" id="accordion_DesignInfo" style={{fontSize: "14px", width: "1208px", marginBottom: "8px"}}>
                                        <div className="accordion-item">
                                            <h2 className="accordion-header" id="headingOne">
                                                    <button className="accordion-button btn-primary" style={{width: "1208px", marginTop: "-20px", fontSize: "14px"}} type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">Industries</button>
                                            </h2>
                                            <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion_DesignInfo">
                                                <div className="accordion-body" style={{padding: "0px"}}>
                                                    <div className="right-col" style={{width: "1208px"}}>
                                                        {industries && industries.map((ind) => (
                                                            <div className="form-control" key={ind["key"]} style={{width: "599px", height: "32px", padding: "8px", display: "inline-flex", alignItems: "center", margin: "2px"}}>
                                                                <input value={ind["value"]} style={{height: "24px", marginRight: "8px"}} type="checkbox" id={`cbInd_${ind["key"]}`} dataname={ind["text"]} defaultChecked={ind["checked"]}/>&nbsp;{ind["text"]}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>

                            </form>  
                            <Link to="/Sites" className="btn btn-default" style={{marginRight: "4px"}}>Cancel</Link>                              
                            <button onClick={handleFormSubmit} className="btn btn-primary" style={{marginRight: "4px"}}>Save</button>                            
                        </div>
                    }
                </>
            }
        </div>
    );
}
 
export default SitesEdit;